import {AirwayCollapse} from '../animations/AirwayCollapse';
import {ScienceScreen} from './ScienceScreen';

export const AngerScience = () => (
  <ScienceScreen
    headline="Your effort wasn't wrong. It was just aimed somewhere it couldn't help."
    body={
      <>
        <p>
          <strong>Sleep apnea is mechanical.</strong> Your airway partially collapses during sleep — your breath
          actually stops, dozens of times an hour.
        </p>
        <p>
          <strong>Sleep hygiene, supplements, and tracking are behavioral tools.</strong> They can shape your habits,
          but they don't reach your airway.
        </p>
      </>
    }
    animation={<AirwayCollapse />}
    callout="We address what's causing the airway to collapse — not what you do around your routine."
    analyticsShown="GLP-1 Funnel Grief Anger Science Viewed"
    analyticsSubmitted="GLP-1 Funnel Grief Anger Science Submitted"
  />
);

export default AngerScience;
